import * as React from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const WithdrawRow = ({ withdraws }: any) => {
  return (
    <>
      <TableRow>
        <TableCell align="center">{withdraws?.withdrawTypes}</TableCell>
        <TableCell align="center">
          # {withdraws?.transactionId?.slice(-6)}
        </TableCell>
        <TableCell align="center">
          {new Date(withdraws?.dateTime).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </TableCell>
        <TableCell align="center">
          {withdraws?.totalWithdrawableAmount}
        </TableCell>
        <TableCell align="center">
          {withdraws?.matchOrderId === "null"
            ? "N/A"
            : "# " + withdraws?.matchOrderId?.slice(-6)}
        </TableCell>
        <TableCell align="center">
          {withdraws?.matchAmount === 0 ? "N/A" : withdraws?.matchAmount}
        </TableCell>
        <TableCell align="center">{withdraws?.withdrawFees}</TableCell>
        <TableCell align="center">{withdraws?.totalMatchedFees}</TableCell>
        <TableCell align="center">{withdraws?.receivedAmount}</TableCell>
        <TableCell align="center">{withdraws?.paidToBankAccount}</TableCell>
      </TableRow>
    </>
  );
};

export default WithdrawRow;
